// frontend/src/components/Pages/HomePage.js
import React, { useState, useEffect } from 'react';
import authService from '../../services/authService';
import { Link, useNavigate }    from 'react-router-dom'; // Added useNavigate

const HomePage = () => {
    const [accessiblePages, setAccessiblePages] = useState([]);
    const [currentUser, setCurrentUser] = useState(null);
    const [error, setError] = useState('');
    const navigate = useNavigate(); // For redirecting

    useEffect(() => {
        const userSession = authService.getCurrentUser();
        if (userSession && userSession.token) {
            setCurrentUser(userSession.user);
            authService.getAccessiblePages(userSession.token)
                .then(response => {
                    setAccessiblePages(response.data.pages || []);
                })
                .catch(err => {
                    console.error("Error fetching pages:", err);
                    setError("Could not load accessible pages.");
                    if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                        authService.logout();
                        navigate('/login'); // Redirect to login
                    }
                });
        } else {
            setError("User not logged in.");
            navigate('/login'); // Redirect to login
        }
    }, [navigate]); // Added navigate to dependency array

    if (error && !currentUser) { // Show error prominently if no user data and error exists
        return (
            <div className="container mt-5">
                <div className="alert alert-danger text-center" role="alert">
                    <h4>Session Issue</h4>
                    <p>{error}</p>
                    <p>Please <Link to="/login" className="alert-link">login again</Link>.</p>
                </div>
            </div>
        );
    }

    if (!currentUser) {
        return (
            <div className="container mt-5 text-center">
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
                <p className="mt-2">Loading user data...</p>
            </div>
        );
    }

    return (
        <div className="container mt-4"> {/* Main container */}
            <div className="jumbotron bg-light p-4 p-md-5 rounded"> {/* A nice welcome box */}
                <h1 className="display-4">Welcome, {currentUser.username}!</h1>
                <p className="lead">Your assigned role is: <strong>{currentUser.role}</strong></p>
            </div>

            <div className="mt-4">
                <h3>Accessible Pages:</h3>
                {accessiblePages.length > 0 ? (
                    <div className="list-group"> {/* Bootstrap list group for nicer links */}
                        {accessiblePages.map(pageName => (
                            <Link
                                key={pageName}
                                to={`/${pageName.toLowerCase().replace(/\s+/g, '-')}`}
                                className="list-group-item list-group-item-action" // Styled list item
                            >
                                {pageName}
                            </Link>
                        ))}
                    </div>
                ) : (
                    <div className="alert alert-info" role="alert">
                        No specific pages assigned to your role, or still loading.
                    </div>
                )}
            </div>

            <div className="mt-5 p-3 border rounded bg-white shadow-sm">
                <h4 className="mb-3">Full List of Potential Pages <small className="text-muted">(for system reference)</small>:</h4>
                <p className="small text-muted" style={{ wordBreak: 'break-word' }}>
                    1Party, 2Party, 3Party, 4Party, 5Party, 1Carto, 2Carto, Photo Office, GIS, Digital Carto, Boundary Section, Geodesy, Director Office, DPCO, CPT, LPO
                </p>
            </div>
        </div>
    );
};

export default HomePage;